import auth from './authReducer';
import sessionEventBooking from './sessionEventBookingReducer';
import routing from './routingReducer';
import modals from './modalsReducer';
import pendingBooking from './pendingBookingReducer';
import filter from './filterReducer';
import registration from './registrationReducer';
import scrollTo from './scrollToReducer';
import config from './configReducer';
import payment from './paymentReducer';

import requestSuccessFailureReducers from './requestSuccessFailureReducers';

const reducers = {
  auth,
  registration,
  sessionEventBooking,
  routing,
  modals,
  pendingBooking,
  filter,
  config,
  scrollTo,
  payment,
  ...requestSuccessFailureReducers
};

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js